<template>
  <!--
    인증 상태 변경
  -->

  <v-row justify="center">
    <v-dialog v-model="authStateDialog" max-width="380px">
      <v-card>
        <v-card-title>인증상태 변경</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
          <p class="font-weight-bold mt-7 body-2 black--text">인증상태 수정시 참고해주세요.</p>
          <p class="mb-0 font-weight-bold caption">상태 변경시에 고객이 쇼핑몰의 정품 인증 페이지에서</p>
          <p class="mb-0 font-weight-bold caption">변경사항 확인이 가능하게 됩니다.</p>
          <p class="mb-0 font-weight-bold caption">참고하여 운영에 활용하시길 권장합니다.</p>

          <p class="mb-2 font-weight-bold body-2 black--text text-truncate mt-7">
            현재 인증상태는
            <font class="deep-purple--text pb-2">{{ statusText }}</font>
            상태입니다.
          </p>

          <v-col class="pt-3 pl-0 ma-0 pb-0">
            <v-col cols="12" class="pa-0 ma-0">
              <v-select
                v-model="selectStatus"
                :items="authStateTypeItems"
                label="Select"
                persistent-hint
                single-line
                class="pt-0"
                outlined
                dense
                height="50"
                @change="changeCheckMemberShow"
              ></v-select>
            </v-col>
          </v-col>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="authStateDialog = false">닫기</v-btn>
          <v-btn color="blue darken-1" text @click.prevent="changeStatus">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      prd: null,
      memberIdChecked: false,
      authStateDialog: false,
      selectStatus: "",
      statusText: "",
      memberId: "",
      checkMemberShow: false,
      initTypeItems: [
        { text: "변경할 인증상태 선택", value: "" },
        { text: "미인증", value: "inactivated" },
        { text: "인증완료", value: "activated" },
        { text: "분실", value: "lost" }
      ],
      authStateTypeItems: []
    };
  },
  mixins: [CommonMixin],
  methods: {
    /**
     * 초기화
     */
    initData: function() {
      this.prd = null;
      this.memberIdChecked = false;
      this.memberId = "";
      this.selectStatus = "";
      this.statusText = "";
      this.authStateTypeItems = [];
      this.checkMemberShow = false;
    },
    /**
     * 상태변경 다이얼 시작
     */
    authStateClick: function(data) {
      this.initData();
      this.prd = data;
      let statusIndex = this.initTypeItems.findIndex(
        item => item.value === data.cert_status
      );
      this.statusText = this.initTypeItems[statusIndex].text;
      this.initTypeItems.forEach((item, index) => {
        if (index !== statusIndex) {
          this.authStateTypeItems.push(item);
        }
      });
      this.authStateDialog = true;
    },
    /**
     * 상태변경 체크
     */
    changeStatus: async function() {
      if (this.selectStatus === "") {
        this.alertShow("변경할 인증상태를 선택해주세요.");
        return false;
      }
      let payload = {
        cert_status: this.selectStatus
      };

      try {
        await M.api(
          M.entry("/serials/status", this.prd.serial_number),
          payload
        );
        this.authStateDialog = false;
        this.alertShow("정상적으로 인증상태가 변경되었습니다.");
        this.eventHub.$emit("execSearch", false);
      } catch (e) {
        this.alertShow("인증상태 변경이 실패되었습니다.");
        return false;
      }
    },
    /**
     * 유져 유효성 체크
     */
    validateUser: async function() {
      if (this.memberId === "") {
        this.alertShow("회원ID를 다시 확인해주세요.");
        return false;
      }

      try {
        let res = await M.api(M.entry("/user/validate", this.memberId));
        if (res.exists) {
          this.alertShow("정상회원임을 체크하였습니다.");
          this.memberIdChecked = true;
        }
      } catch (e) {
        if (e.response.status === 404 || e.response.status === 500) {
          this.alertShow("회원ID를 다시 확인해주세요.");
        }
      }
    },
    changeCheckMemberShow: function() {
      this.checkMemberShow = false;
      if (this.selectStatus === "activated" || this.selectStatus === "lost") {
        this.checkMemberShow = true;
      }
    }
  }
};
</script>
